import React from 'react';

import { FormStatus, SelectionMode, EntryListingMode, WorkflowStep } from 'model/dictionary';
import EntriesPage from 'components/EntriesPage';

export default function Winners() {

	return (
		<EntriesPage
			title="Ganadores"
			description="Acá se define el ganador de cada premio a partir de la votación del jurado. Elija un premio para ver sus finalistas ordenados por la cantidad de votos recibidos. Marque el ganador y presione Confirmar; una vez elegido, el premio deja de mostrar postulaciones en esta pantalla."
			workflowStep={WorkflowStep.WINNERS}
			entryListMode={EntryListingMode.WINNERS}
			formStatusFiltered={FormStatus.FINALIST}
			formStatusConfirmed={FormStatus.WINNER}
			selectionMode={SelectionMode.SIMPLE}
		/>
	);
}
